import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  fieldDisabledWithIcon: css`
    .mantine-Input-rightSection {
      display: flex !important;
      opacity: 0.5;
    }
    .mantine-TextInput-input {
      opacity: 0.5;
    }
  `,
  timeSectionFlexbox: theme => css`
    display: flex;
    gap: ${theme.spacing.xxs};
    padding: ${theme.spacing.xxs};
  `,
})

export default useStyles
